import React from 'react';
import { NotificationT } from '~/libs/soopI18n';

const AlertLayer = ({
    form,
    onClose
}: {
    form: React.ReactNode;
    onClose: () => void;
}) => {
    return (
        <div className={'basic_alert'}>
            {form}
            <div className="btn_area">
                <button type="button" onClick={onClose}>
                    {NotificationT('확인')}
                </button>
            </div>
        </div>
    );
};

export default AlertLayer;
